import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Users } from 'lucide-react';

const CTA = () => (
  <section className="py-24 bg-forest-900 relative overflow-hidden">
    <div className="absolute inset-0 pointer-events-none overflow-hidden">
      <div className="absolute -top-24 -right-24 w-96 h-96 bg-forest-700/30 rounded-full" />
      <div className="absolute -bottom-24 -left-24 w-80 h-80 bg-rust-500/10 rounded-full" />
    </div>
    <div className="max-w-4xl mx-auto px-6 lg:px-10 text-center relative">
      <div className="inline-flex items-center gap-2 text-xs font-medium tracking-widest uppercase text-gold-400 mb-6">
        <Users size={12} /> Join 1,200+ Entrepreneurs
      </div>
      <h2 className="font-serif text-3xl lg:text-5xl font-semibold text-cream-50 leading-tight mb-6">
        Ready to build your<br/>
        <span className="italic text-gold-400">enterprise ?</span>
      </h2>
      <p className="text-forest-300/80 text-base lg:text-lg mb-10 max-w-xl mx-auto leading-relaxed">
        Join the fastest-growing entrepreneurship community. Get matched with the right expert and start your journey today.
      </p>
      <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Link to="/register" className="btn-rust text-base px-10 py-4 inline-flex items-center gap-2">
          Get Started for Free <ArrowRight size={16} />
        </Link>
        <Link to="/experts" className="inline-flex items-center gap-2 border border-forest-600 text-cream-100 px-10 py-4 rounded-full font-medium text-base transition-all duration-300 hover:bg-forest-800 hover:border-forest-500">
          Browse Experts
        </Link>
      </div>
    </div>
  </section>
);

export default CTA;